import axios from "axios";
import { getToken } from "../utils/authStorage";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5010/api";

// Interfaces
export interface FilterCondition {
  field: string;
  operator: "=" | "!=" | ">" | ">=" | "<" | "<=" | "between";
  value: string | number | boolean | [number, number];
}

export interface FollowUpFilters {
  logic?: "AND" | "OR";
  conditions?: FilterCondition[];
}

export interface FollowUpBooking {
  bookingId: string;
  bookingDate: string;
  customerName: string;
  customerContact: string;
  projectName: string;
  unitRef: string;
  unitType: string;
  wing: string;
  paymentTerms: string;
  totalAmount: number;
  receivedAmount: number;
  pendingAmount: number;
  pendingPercent: number;
  receivedPercent: number;
  paymentCount: number;
  lastPaymentDate: string | null;
  lastPaymentAmount: number | null;
  daysSinceBooking: number;
  daysSinceLastPayment: number | null;
  status: string;
}

export interface KPIs {
  totalBookings: number;
  totalPending: number;
  totalReceived: number;
  averagePendingPercent: number;
  highRiskBookings: number;
}

export interface Project {
  id: number;
  name: string;
}

export interface FollowUpReportData {
  kpis: KPIs;
  bookings: FollowUpBooking[];
  projects: Project[];
}

class FollowUpReportService {
  /**
   * Get follow-up report data with optional dynamic filters
   */
  async getFollowUpReportData(
    projectId?: string,
    dateFrom?: string,
    dateTo?: string,
    filters?: FollowUpFilters
  ): Promise<FollowUpReportData> {
    const token = getToken();
    const payload: any = {};

    if (projectId) payload.projectId = projectId;
    if (dateFrom) payload.dateFrom = dateFrom;
    if (dateTo) payload.dateTo = dateTo;
    if (filters) payload.filters = filters;

    const response = await axios.post(`${API_URL}/reports/follow-up/data`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }
}

export default new FollowUpReportService();
